import React from 'react';

import Layout from '../components/layout_cookie_policy';
import HeroPageIntro from '../sections/HeroPageIntro';
import LayoutPageWrapper from '../components/LayoutPageWrapper';
import Heading from '../components/Heading';

const IndexPage = () => (
  <Layout>
    <HeroPageIntro title="Cookie Policy" />
    <LayoutPageWrapper horizontalPadding="Small">

      <p>Date: March 4 2022</p>
      <p>Version: 2.1</p>

      <Heading type="h2" size="Small">Section 1. Legal Aspects</Heading>

      <p>1. This document (hereinafter referred to as “Cookie Policy”), together with the <a href="/privacy" target="_blank" title="Go to Privacy Policy">Privacy Policy</a> and the <a href="/terms" target="_blank" title="Go to Terms of Service">Terms of Service</a> represent the contract between the user (hereinafter “User” or “you”) with us, Endtest Inc., a Delaware company, email: contact@endtest.io (hereinafter referred to as “us” or “we”, or similar).</p>
      <p>2. The contract regulates the access and use of the website www.endtest.io (hereinafter referred to as the “website”). We encourage you to read and corroborate all of the above legal documents.</p>

      <Heading type="h2" size="Small">Section 2. What are the cookies</Heading>

      <p>3. A cookie module or cookie (hereinafter “cookie”) is a small text file that the browsing equipment downloads when you access our website. The cookies are further transmitted to our website each time you return to it or to another website which recognizes that cookie module, in order to monitor the online activity of the User.</p>
      <p>4. Cookies are not and do not contain viruses, but they store information regarding the preferences and the User’s online navigation and activity. They may be used as a form of spyware by malicious persons.</p>

      <Heading type="h2" size="Small">Section 3. User’s informed consent</Heading>

      <p>5. You have the right to be informed on the cookies and the way they work, in order to take the necessary precaution, so as to safely navigate on our website, by protecting your privacy.</p>
      <p>6. Your informed consent is required for the use by our website of cookies beforehand. This consent is required for non-necessary/optional cookies (e.g. marketing, statistics, analytics). On the other hand, your consent is not required for necessary cookies. By necessary cookies we mean, among others, those which are absolutely necessary for the use of the website from a technical or legal point of view, and other such instruments (e.g. consent cookies).</p>
      <p>7. By clicking the button “ACCEPT ALL” from the consent banner, you give your explicit consent for the use of all cookies mentioned in this document. You have the possibility to select what kind of optional cookies may be used (other than necessary cookies), by selecting them in the consent banner; subsequently you will need to confirm the selected cookies by clicking “SAVE & CLOSE”. You can also choose to reject all optional cookies, by selecting “DECLINE ALL”.</p>
      <p>8. Your option regarding cookies shall be stored for a period of 1 year. At any point during time you may change your option through the settings in your web browser or by contacting us at contact@endtest.io.</p>

      <Heading type="h2" size="Small">Section 4. What cookies do we use?</Heading>

      <p></p>
      <table>
        <tr>
          <th>Name</th>
          <th>Provider</th>
          <th>Purpose</th>
          <th>Expiry</th>
          <th>Type</th>
        </tr>

        <tr>
          <td>NECESSARY COOKIES</td>
          <td></td>
          <td></td>
          <td></td>
          <td>Necessary</td>
        </tr>

        <tr>
          <td>CookieScriptConsent</td>
          <td>CookieScript</td>
          <td>Stores the user's cookie consent state for the current domain</td>
          <td>1 year</td>
          <td>HTTP Necessary</td>
        </tr>

        <tr>
          <td>ceva_orbtset</td>
          <td>Endtest</td>
          <td>Stores the session cookie for the user in the Endtest platform.</td>
          <td>1 year</td>
          <td>HTTP Necessary</td>
        </tr>

        <tr>
          <td>PHPSESSID</td>
          <td>Endtest</td>
          <td>Stores the PHP session information.</td>
          <td>30 minutes</td>
          <td>HTTP Necessary</td>
        </tr>

        <tr>
          <td>OPTIONAL COOKIES</td>
          <td></td>
          <td></td>
          <td></td>
          <td>Statistics</td>
        </tr>

        <tr>
          <td>_ga</td>
          <td>Google</td>
          <td>Registers a unique ID that is used to generate statistical data on how the visitor uses the website.</td>
          <td>2 years</td>
          <td>HTTP Statistic</td>
        </tr>

        <tr>
          <td>_gat</td>
          <td>Google</td>
          <td>Used by Google Analytics to throttle request rate.</td>
          <td>1 day</td>
          <td>HTTP Statistic</td>
        </tr>

        <tr>
          <td>_gid</td>
          <td>Google</td>
          <td>Registers a unique ID that is used to generate statistical data on how the visitor uses the website.</td>
          <td>1 day</td>
          <td>HTTP Statistic</td>
        </tr>

        <tr>
          <td>driftt_aid</td>
          <td>Drift.com</td>
          <td>Stores a unique user ID for the Drift chat.</td>
          <td>1 year</td>
          <td>HTTP Statistic</td>
        </tr>

        <tr>
          <td>drift_aid</td>
          <td>Drift.com</td>
          <td>Stores a unique user ID for the Drift chat.</td>
          <td>1 year</td>
          <td>HTTP Statistic</td>
        </tr>

        <tr>
          <td>fs_uid</td>
          <td>FullStory</td>
          <td>Stores a unique user ID for FullStory.</td>
          <td>1 year</td>
          <td>HTTP Statistic</td>
        </tr>
        </table>

        <p></p>

      <Heading type="h2" size="Small">Section 5. How can you eliminate cookies</Heading>

      <p>9. The website will recognize your web browser, based on the cookies stored, until such cookies are eliminated or expire.</p>
      <p>10. You may use your web browser settings to eliminate certain cookies or to block them in the future. Also, you can refuse the use of cookies on this website, except for necessary cookies. In this case, the website’s use may be affected by interruptions or dysfunctionalities.</p>
      <p>11. If you wish to learn more about cookies and their role (including the web browser settings for blocking the cookies) you can visit dedicated websites such as All About Cookies. (http://www.allaboutcookies.org/ ) or  Your Online Choices.( http://www.youronlinechoices.eu/).</p>

    </LayoutPageWrapper>
  </Layout>
);

export default IndexPage;
